import api from './api';
import util from '@/common/util';
import facebook from './facebook';
import aiDialogFlow, { aiInit } from './chime/aiDialogFlow';
const getChatYunTwilio = async function () {
    let res = await import('./chime');
    return res.default;
};

var facebook_cms_inst = {
    $el: null,
    $mount() {
        if (this.$el) {
            return;
        }
        let img = new Image();
        img.src =
            '//cdn.chime.me/image/fs/sitebuild/site-cms/chat-facebook-icon.png';
        img.style.width = '60px';
        img.style.height = '60px';
        img.style.position = 'fixed';
        img.style.right = '12px';
        img.style.bottom = '24px';
        img.style.top = 'auto';
        img.style.zIndex = 2147483644;
        img.style.borderRadius = '50%';
        img.style.overflow = 'hidden';
        this.$el = img;
    },
    $destroy() {}
};
const facebook_cms = {
    createIns() {
        return Promise.resolve(facebook_cms_inst);
    }
};

const chatFactory = {
    chime: getChatYunTwilio,
    facebook: facebook,
    chime_cms: getChatYunTwilio,
    facebook_cms
};
var chatPs;
const chat = {
    checkUserAction: function () {
        if (!chatPs) {
            if (window.sitePageAutoInit === false) {
                chatPs = Promise.resolve();
            } else {
                chatPs = util.getUserActionPs();
            }
        }
        return chatPs;
    },

    //  create chat example ( When called repeatedly, the previous instance will be destroyed ,  always only one chat example : Right now chat.curChatIns)
    init: function (siteAppVm, globalData = {}, logOutFlag = false) {
        //  Reinitialize on logout chat
        if (logOutFlag) {
            util.removeCookie('chatbox_visitor_session_id');
            util.removeCookie('chatbox_visitor_id');
        }
        // this.checkUserAction().then(() => {
        let config = globalData.chatAndCaptureForm || {};
        let showLauncher = config.showLauncher;
        let { CHAT_AGENT_ID, agentCreator, siteType } =
            siteAppVm.$store.state.page.page;
        // only showLauncher for true only displayed when chat-box, highest priority 
        if (showLauncher) {
            config.isMobile = util.isMobile;
            let params = {
                leadUserId:
                    (siteAppVm.$store.state.user.user &&
                        siteAppVm.$store.state.user.user.id) ||
                    '',
                sessionId: util.getCookie('chatbox_visitor_session_id') || '',
                agentId: CHAT_AGENT_ID || agentCreator?.agentId || ''
            };
            // company site
            if (globalData.siteLevel === 1) {
                params.userId = globalData.ownerId;
                params.siteId = globalData.siteId;
            }
            // office site
            else if (globalData.siteLevel === 2) {
                params.officeId = globalData.ownerId;
                params.siteId = globalData.siteId;
            } else {
                params.userId = CHAT_AGENT_ID;
            }
            //  Get it through the interface first AI Related Information 
            api.getVisitorToken(params).then(async res => {
                config = {
                    chatAgentId: CHAT_AGENT_ID,
                    chatType: 'chime',
                    ...config,
                    visitorEnable: res.visitorEnable,
                    visitLead: res.visitLead,
                    aiHeadurl: res.headurl,
                    aiHeadname: res.aiHeadname
                };
                // util.inCms &&  is a template site :  mandatory  leaveMode
                if (util.inCms && siteType === 99) {
                    config.messenger = false;
                    config.visitorEnable = false;
                    config.leaveMode = true;
                }
                //  if enabled AI,  Mandatory use chime chat
                if (config.visitorEnable) {
                    if (!showLauncher) {
                        chat.destroyChat();
                        return;
                    }
                    config.chatType = 'chime';
                }
                //  If configured  facebook  use  facebook
                else if (config.messenger) {
                    config.chatType = 'facebook';
                }

                //  maintain sessionId,  this sessionId changed retrigger aiflow
                if (config.visitLead && config.visitLead.id) {
                    var oldVistorId = util.getCookie(
                        'chatbox_visitor_session_id'
                    );
                    //  if visitorId changed ,  empty aiFlow relevant local data 
                    if (oldVistorId !== config.visitLead.sessionId) {
                        window.localStorage.removeItem('set-site-welcome');
                        window.localStorage.removeItem('set-listing-page');
                        window.localStorage.removeItem('set-site-followup');
                        window.localStorage.removeItem(
                            'set-site-followup_final'
                        );
                    }
                    util.setCookie(
                        'chatbox_visitor_session_id',
                        config.visitLead.sessionId,
                        30
                    );
                    util.setCookie(
                        'chatbox_visitor_id',
                        config.visitLead.id,
                        30
                    );
                }

                //  Save the latest configuration 
                chat.config = config;
                //  according to chatType,  get the corresponding chat the code 

                var chatFact =
                    chatFactory[config.chatType + (util.inCms ? '_cms' : '')];
                if (!chatFact) {
                    return;
                }
                if (util.isFunction(chatFact)) {
                    chatFact = await chatFact();
                }
                if (chatFact) {
                    chatFact
                        .createIns(config, siteAppVm)
                        .then(instance => {
                            if (!instance) {
                                return;
                            }
                            chat.destroyChat();
                            chat.curChatIns = instance;
                            chat.onCreated();
                            instance.$mount();
                            document && document.body.appendChild(instance.$el);
                        })
                        .catch(err => {
                            console.log('chat init error:', err);
                        });
                }
            });
        } else {
            chat.destroyChat();
        }
        // });
        aiDialogFlow({ agentId: CHAT_AGENT_ID });
        aiInit();
    },

    //  destroy chat example 
    destroyChat: function () {
        if (chat.curChatIns) {
            chat.curChatIns.$el && chat.curChatIns.$el.remove();
            chat.curChatIns.$destroy();
        }
    },
    onCreated: function () {
        if (chat.onCreatedCallback) {
            chat.onCreatedCallback();
            chat.onCreatedCallback = undefined;
        }
    }
};

window.chimeChat = chat;

export default chat;
